import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-red-500 text-sm font-semibold"
}
const _hoisted_2 = {
  key: 2,
  class: "w-full"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "text-[10px] text-white font-medium mb-2" }
const _hoisted_5 = { class: "flex justify-center items-center gap-1.5 w-full mb-2" }
const _hoisted_6 = { class: "text-[14px] text-white font-medium select-all" }
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "size-4 text-gray-100",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = {
  key: 1,
  class: "size-4 text-green-300",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "text-[13px] text-white text-center mb-3 bg-black/70 px-2 py-0.5 rounded-lg" }
const _hoisted_11 = {
  key: 0,
  class: "text-gray-50 text-[12px]"
}
const _hoisted_12 = {
  key: 1,
  class: "text-red-200 text-[12px]"
}

export function render(_ctx, _cache) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: "flex justify-center items-center w-full",
    pt: { root: _ctx.getBankBgClass(_ctx.bank.bankName), body: 'p-0!' }
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            style: {"width":"50px","height":"50px"},
            strokeWidth: "4",
            fill: "transparent",
            animationDuration: ".5s"
          }))
        : (!_ctx.isActive)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " บัญชีไม่พร้อมใช้งาน "))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.getBankImage(_ctx.bank.bankName),
                alt: _ctx.bank.bankName || 'bank-logo',
                class: "size-14 mx-auto my-3"
              }, null, 8 /* PROPS */, _hoisted_3),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.bank.bankName || 'ไม่พบข้อมูล'), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.bank.bankNumber || 'ไม่พบข้อมูล'), 1 /* TEXT */),
                (_ctx.isCopyNumber && _ctx.bank.bankNumber)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                      type: "button",
                      class: "cursor-pointer",
                      title: _ctx.copied ? 'คัดลอกแล้ว' : 'คัดลอกเลขบัญชี',
                      "aria-label": "คัดลอกเลขบัญชี"
                    }, [
                      (!_ctx.copied)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[1] || (_cache[1] = [
                            _createElementVNode("path", {
                              stroke: "currentColor",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M14 4v3a1 1 0 0 1-1 1h-3m4 10v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2m11-3v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H18a1 1 0 0 1 1 1Z"
                            }, null, -1 /* HOISTED */)
                          ])))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_9, _cache[2] || (_cache[2] = [
                            _createElementVNode("path", {
                              d: "M20 6L9 17l-5-5",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1 /* HOISTED */)
                          ])))
                    ], 8 /* PROPS */, _hoisted_7))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.bank.fullName || '—'), 1 /* TEXT */),
              (_ctx.remaining > 0 && _ctx.showAmount > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " ฝาก " + _toDisplayString(_ctx.formatCurrency(_ctx.showAmount)) + " ภายใน " + _toDisplayString(_ctx.remaining) + " วินาที ", 1 /* TEXT */))
                : (_ctx.showAmount > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, " หมดเวลาแล้ว กรุณาสร้างรายการใหม่ "))
                  : _createCommentVNode("v-if", true)
            ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["pt"]))
}